// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   QINTRA REAL EXECUTION API ENGINE STUDIO - ENTERPRISE DESIGN SYSTEM
   ========================================================================== */

.realapi-container {
  padding: 24px 32px 48px;
  color: #0f172a;
  background-color: #f8fafc;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  box-sizing: border-box;
}

/* 1. HERO HEADER BANNER */
.realapi-hero {
  background: #ffffff;
  border: 1px solid rgba(226, 232, 240, 0.85);
  border-radius: 20px;
  padding: 22px 28px;
  margin-bottom: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  box-shadow: 0 4px 20px -2px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.02);
}

.realapi-hero-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.realapi-hero-icon {
  background: #FD6101;
  color: #ffffff;
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  box-shadow: 0 8px 18px -4px rgba(253, 97, 1, 0.35);
  flex-shrink: 0;
}

.realapi-hero-title-group h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.4px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.realapi-mandate-badge {
  font-size: 10.5px;
  background: #FD6101;
  color: #ffffff;
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  box-shadow: 0 2px 8px rgba(253, 97, 1, 0.25);
}

.realapi-hero-subtext {
  color: #64748b;
  font-size: 13px;
  margin: 5px 0 0 0;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.realapi-hero-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.realapi-stat-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
}

.realapi-pulse-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);
  display: inline-block;
  animation: pulseDot 2s infinite ease-in-out;
}

@keyframes pulseDot {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 6px rgba(16, 185, 129, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
  }
}

.realapi-action-btn {
  background-color: #ffffff;
  color: #0f172a;
  border: 1.5px solid #cbd5e1;
  padding: 9px 16px;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 700;
  font-size: 12.5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.realapi-action-btn:hover {
  border-color: #FD6101;
  color: #FD6101;
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(253, 97, 1, 0.12);
}

.realapi-action-btn.active {
  background-color: #fff7ed;
  border-color: #FD6101;
  color: #FD6101;
}

/* 2. MAIN TABS */
.realapi-nav-tabs-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  flex-wrap: wrap;
  gap: 12px;
}

.realapi-nav-tabs {
  display: flex;
  gap: 6px;
  background: #f1f5f9;
  border-radius: 14px;
  padding: 5px;
  border: 1px solid #e2e8f0;
}

.realapi-nav-tab {
  padding: 9px 20px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  border: none;
  background: transparent;
  color: #64748b;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.realapi-nav-tab:hover {
  color: #0f172a;
}

.realapi-nav-tab.active {
  background: #ffffff;
  color: #FD6101;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.realapi-quick-presets {
  display: flex;
  align-items: center;
  gap: 8px;
}

.realapi-preset-pill {
  padding: 6px 12px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 11.5px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  transition: all 0.15s ease;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.realapi-preset-pill:hover {
  border-color: #FD6101;
  color: #FD6101;
  background-color: #fff7ed;
  transform: translateY(-1px);
}

/* 3. COMMAND BAR (METHOD + URL + SEND) */
.realapi-command-bar {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 12px 16px;
  margin-bottom: 22px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.03);
}

.realapi-method-select {
  height: 42px;
  padding: 0 14px;
  border-radius: 10px;
  font-weight: 800;
  font-size: 13px;
  cursor: pointer;
  outline: none;
  border: 1.5px solid #cbd5e1;
  background-color: #f8fafc;
  transition: all 0.2s ease;
}

.realapi-method-select.method-get {
  color: #059669;
  border-color: #a7f3d0;
  background-color: #ecfdf5;
}

.realapi-method-select.method-post {
  color: #FD6101;
  border-color: #fed7aa;
  background-color: #fff7ed;
}

.realapi-method-select.method-put {
  color: #FD6101;
  border-color: #bfdbfe;
  background-color: #eff6ff;
}

.realapi-method-select.method-patch {
  color: #7c3aed;
  border-color: #ddd6fe;
  background-color: #f5f3ff;
}

.realapi-method-select.method-delete {
  color: #dc2626;
  border-color: #fca5a5;
  background-color: #fef2f2;
}

.realapi-method-select.method-options,
.realapi-method-select.method-head {
  color: #475569;
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.realapi-url-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1;
}

.realapi-url-prefix-icon {
  position: absolute;
  left: 14px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  pointer-events: none;
  font-size: 13px;
}

.realapi-url-input {
  width: 100%;
  height: 42px;
  background-color: #f8fafc;
  color: #0f172a;
  border: 1.5px solid #cbd5e1;
  border-radius: 10px;
  padding: 0 34px 0 38px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 13px;
  font-weight: 500;
  outline: none;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.realapi-url-input:hover {
  border-color: #94a3b8;
  background-color: #ffffff;
}

.realapi-url-input:focus {
  border-color: #FD6101;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(253, 97, 1, 0.15);
}

.realapi-url-clear-btn {
  position: absolute;
  right: 10px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #e2e8f0;
  border: none;
  color: #64748b;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  line-height: 1;
}

.realapi-url-clear-btn:hover {
  background-color: #cbd5e1;
  color: #0f172a;
}

.realapi-send-btn {
  height: 42px;
  background: #10b981;
  color: #ffffff;
  border: none;
  padding: 0 24px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13.5px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.realapi-send-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.35);
}

.realapi-send-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none;
}

.realapi-send-shortcut {
  font-size: 10.5px;
  background: rgba(255, 255, 255, 0.22);
  padding: 2px 6px;
  border-radius: 5px;
  font-weight: 600;
}

/* 4. WORKBENCH TWO-PANEL STUDIO GRID */
.realapi-studio-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 22px;
  min-height: calc(100vh - 280px);
  align-items: stretch;
}

@media (max-width: 1200px) {
  .realapi-studio-grid {
    grid-template-columns: 1fr;
  }
}

.realapi-card {
  background-color: #ffffff;
  border-radius: 18px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 8px 24px -4px rgba(0, 0, 0, 0.03), 0 2px 6px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.realapi-card-header {
  padding: 18px 22px 14px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  background-color: #fafbfc;
}

.realapi-card-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 8px;
}

.realapi-sub-tabs {
  display: flex;
  gap: 4px;
  background: #f1f5f9;
  border-radius: 10px;
  padding: 3px;
  border: 1px solid #e2e8f0;
}

.realapi-sub-tab {
  padding: 6px 14px;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  background: transparent;
  color: #64748b;
  transition: all 0.15s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.realapi-sub-tab.active {
  background: #ffffff;
  color: #0f172a;
  font-weight: 700;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.realapi-badge-count {
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 10px;
  background: #e2e8f0;
  color: #475569;
  font-weight: 700;
}

.realapi-sub-tab.active .realapi-badge-count {
  background: #FD6101;
  color: #ffffff;
}

.realapi-card-body {
  padding: 20px 22px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

/* 5. TABLE BUILDER FOR PARAMS & HEADERS */
.realapi-kv-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 14px;
}

.realapi-kv-table th {
  text-align: left;
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 8px 10px;
  border-bottom: 1px solid #e2e8f0;
}

.realapi-kv-table td {
  padding: 6px 6px;
  border-bottom: 1px solid #f1f5f9;
}

.realapi-kv-input {
  width: 100%;
  height: 36px;
  background-color: #f8fafc;
  color: #0f172a;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 12.5px;
  outline: none;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  box-sizing: border-box;
}

.realapi-kv-input:focus {
  border-color: #FD6101;
  background-color: #ffffff;
}

.realapi-kv-del-btn {
  background: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.realapi-kv-del-btn:hover {
  background-color: #fee2e2;
  color: #dc2626;
}

.realapi-table-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

.realapi-link-btn {
  background: transparent;
  border: none;
  color: #FD6101;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.realapi-link-btn:hover {
  background-color: #fff7ed;
}

/* 6. BODY CONFIGURATION */
.realapi-body-types {
  display: flex;
  gap: 14px;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f5f9;
}

.realapi-radio-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.realapi-body-editor {
  width: 100%;
  flex: 1 1;
  min-height: 240px;
  background-color: #0f172a;
  color: #38bdf8;
  border: 1.5px solid #1e293b;
  border-radius: 12px;
  padding: 16px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12.5px;
  line-height: 1.5;
  outline: none;
  box-sizing: border-box;
  resize: vertical;
}

.realapi-body-editor:focus {
  border-color: #FD6101;
}

/* 7. AUTH CONFIGURATION */
.realapi-auth-box {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 18px;
}

/* 8. RESPONSE TELEMETRY HEADER */
.realapi-telemetry-header {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid #f1f5f9;
}

.realapi-status-badge {
  padding: 7px 14px;
  border-radius: 9px;
  font-weight: 800;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.realapi-status-badge.status-2xx {
  background-color: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

.realapi-status-badge.status-3xx {
  background-color: #eff6ff;
  color: FD6101;
  border: 1px solid #bfdbfe;
}

.realapi-status-badge.status-4xx {
  background-color: #fff7ed;
  color: #ea580c;
  border: 1px solid #fed7aa;
}

.realapi-status-badge.status-5xx {
  background-color: #fef2f2;
  color: #dc2626;
  border: 1px solid #fca5a5;
}

.realapi-status-badge.status-err {
  background-color: #fef2f2;
  color: #dc2626;
  border: 1px solid #fca5a5;
}

.realapi-metric-pill {
  padding: 7px 12px;
  border-radius: 9px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  font-size: 12px;
  font-weight: 700;
  color: #334155;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* 9. SOCKET PHASE WATERFALL CHART */
.realapi-waterfall-card {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 18px 20px;
  margin-bottom: 16px;
}

.realapi-waterfall-title {
  font-size: 11.5px;
  font-weight: 800;
  color: #FD6101;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.realapi-waterfall-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 12px;
  gap: 12px;
}

.realapi-waterfall-label {
  width: 130px;
  font-weight: 600;
  color: #475569;
  flex-shrink: 0;
}

.realapi-waterfall-track {
  flex: 1 1;
  background-color: #e2e8f0;
  height: 10px;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}

.realapi-waterfall-bar {
  height: 100%;
  border-radius: 5px;
  transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.realapi-waterfall-val {
  width: 75px;
  text-align: right;
  font-weight: 800;
  color: #0f172a;
  flex-shrink: 0;
  font-family: ui-monospace, SFMono-Regular, monospace;
}

/* 10. RESPONSE BODY PREVIEW */
.realapi-response-body-box {
  background-color: #0f172a;
  color: #a7f3d0;
  padding: 16px 20px;
  border-radius: 12px;
  overflow: auto;
  flex: 1 1;
  min-height: 250px;
  max-height: 480px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  line-height: 1.6;
  border: 1px solid #1e293b;
  margin: 0;
}

/* 11. EMPTY STATE LAUNCHPAD */
.realapi-empty-launchpad {
  padding: 36px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.realapi-empty-icon {
  width: 68px;
  height: 68px;
  border-radius: 20px;
  background: #fff7ed;
  border: 1.5px solid #fed7aa;
  color: #FD6101;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  margin-bottom: 16px;
  box-shadow: 0 8px 20px -4px rgba(253, 97, 1, 0.2);
}

.realapi-empty-title {
  font-size: 17px;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 6px 0;
}

.realapi-empty-subtext {
  font-size: 13px;
  color: #64748b;
  max-width: 440px;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.realapi-sample-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  width: 100%;
  max-width: 520px;
  text-align: left;
}

.realapi-sample-card {
  background-color: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.realapi-sample-card:hover {
  border-color: #FD6101;
  background-color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px -2px rgba(253, 97, 1, 0.12);
}

.realapi-sample-method {
  font-size: 10px;
  font-weight: 800;
  padding: 2px 7px;
  border-radius: 6px;
  display: inline-block;
  margin-bottom: 5px;
}

.realapi-sample-title {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 3px;
}

.realapi-sample-desc {
  font-size: 11px;
  color: #64748b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 12. HISTORY DRAWER */
.realapi-history-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 380px;
  background-color: #ffffff;
  border-left: 1px solid #e2e8f0;
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.08);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  animation: slideDrawer 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideDrawer {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}

.realapi-history-header {
  padding: 20px 22px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.realapi-history-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 14px;
}

.realapi-history-item {
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.15s ease;
  background-color: #fafbfc;
}

.realapi-history-item:hover {
  border-color: #FD6101;
  background-color: #ffffff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}`, "",{"version":3,"sources":["webpack://./src/pages/RealApiTesting.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,uGAAuG;EACvG,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,6CAA6C;EAC7C,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE;IACE,sBAAsB;IACtB,2CAA2C;EAC7C;;EAEA;IACE,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;IACtB,yCAAyC;EAC3C;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,iDAAiD;EACjD,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,+CAA+C;EAC/C,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,8EAA8E;EAC9E,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,6EAA6E;EAC7E,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,6EAA6E;EAC7E,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,oDAAoD;AACtD;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,SAAO;EACP,iBAAiB;EACjB,iBAAiB;EACjB,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;EAC9B,4CAA4C;EAC5C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,0CAA0C;AAC5C","sourcesContent":["/* ==========================================================================\n   QINTRA REAL EXECUTION API ENGINE STUDIO - ENTERPRISE DESIGN SYSTEM\n   ========================================================================== */\n\n.realapi-container {\n  padding: 24px 32px 48px;\n  color: #0f172a;\n  background-color: #f8fafc;\n  min-height: 100vh;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  box-sizing: border-box;\n}\n\n/* 1. HERO HEADER BANNER */\n.realapi-hero {\n  background: #ffffff;\n  border: 1px solid rgba(226, 232, 240, 0.85);\n  border-radius: 20px;\n  padding: 22px 28px;\n  margin-bottom: 22px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  box-shadow: 0 4px 20px -2px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.02);\n}\n\n.realapi-hero-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.realapi-hero-icon {\n  background: #FD6101;\n  color: #ffffff;\n  width: 52px;\n  height: 52px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  box-shadow: 0 8px 18px -4px rgba(253, 97, 1, 0.35);\n  flex-shrink: 0;\n}\n\n.realapi-hero-title-group h1 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 800;\n  color: #0f172a;\n  letter-spacing: -0.4px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.realapi-mandate-badge {\n  font-size: 10.5px;\n  background: #FD6101;\n  color: #ffffff;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  box-shadow: 0 2px 8px rgba(253, 97, 1, 0.25);\n}\n\n.realapi-hero-subtext {\n  color: #64748b;\n  font-size: 13px;\n  margin: 5px 0 0 0;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.realapi-hero-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.realapi-stat-pill {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.realapi-pulse-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #10b981;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);\n  display: inline-block;\n  animation: pulseDot 2s infinite ease-in-out;\n}\n\n@keyframes pulseDot {\n  0% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4);\n  }\n\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 6px rgba(16, 185, 129, 0);\n  }\n\n  100% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);\n  }\n}\n\n.realapi-action-btn {\n  background-color: #ffffff;\n  color: #0f172a;\n  border: 1.5px solid #cbd5e1;\n  padding: 9px 16px;\n  border-radius: 12px;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 12.5px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.realapi-action-btn:hover {\n  border-color: #FD6101;\n  color: #FD6101;\n  transform: translateY(-1px);\n  box-shadow: 0 3px 8px rgba(253, 97, 1, 0.12);\n}\n\n.realapi-action-btn.active {\n  background-color: #fff7ed;\n  border-color: #FD6101;\n  color: #FD6101;\n}\n\n/* 2. MAIN TABS */\n.realapi-nav-tabs-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 18px;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.realapi-nav-tabs {\n  display: flex;\n  gap: 6px;\n  background: #f1f5f9;\n  border-radius: 14px;\n  padding: 5px;\n  border: 1px solid #e2e8f0;\n}\n\n.realapi-nav-tab {\n  padding: 9px 20px;\n  border-radius: 10px;\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.realapi-nav-tab:hover {\n  color: #0f172a;\n}\n\n.realapi-nav-tab.active {\n  background: #ffffff;\n  color: #FD6101;\n  font-weight: 700;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.realapi-quick-presets {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.realapi-preset-pill {\n  padding: 6px 12px;\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #475569;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.realapi-preset-pill:hover {\n  border-color: #FD6101;\n  color: #FD6101;\n  background-color: #fff7ed;\n  transform: translateY(-1px);\n}\n\n/* 3. COMMAND BAR (METHOD + URL + SEND) */\n.realapi-command-bar {\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 12px 16px;\n  margin-bottom: 22px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.03);\n}\n\n.realapi-method-select {\n  height: 42px;\n  padding: 0 14px;\n  border-radius: 10px;\n  font-weight: 800;\n  font-size: 13px;\n  cursor: pointer;\n  outline: none;\n  border: 1.5px solid #cbd5e1;\n  background-color: #f8fafc;\n  transition: all 0.2s ease;\n}\n\n.realapi-method-select.method-get {\n  color: #059669;\n  border-color: #a7f3d0;\n  background-color: #ecfdf5;\n}\n\n.realapi-method-select.method-post {\n  color: #FD6101;\n  border-color: #fed7aa;\n  background-color: #fff7ed;\n}\n\n.realapi-method-select.method-put {\n  color: #FD6101;\n  border-color: #bfdbfe;\n  background-color: #eff6ff;\n}\n\n.realapi-method-select.method-patch {\n  color: #7c3aed;\n  border-color: #ddd6fe;\n  background-color: #f5f3ff;\n}\n\n.realapi-method-select.method-delete {\n  color: #dc2626;\n  border-color: #fca5a5;\n  background-color: #fef2f2;\n}\n\n.realapi-method-select.method-options,\n.realapi-method-select.method-head {\n  color: #475569;\n  border-color: #cbd5e1;\n  background-color: #f8fafc;\n}\n\n.realapi-url-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n\n.realapi-url-prefix-icon {\n  position: absolute;\n  left: 14px;\n  color: #94a3b8;\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n  font-size: 13px;\n}\n\n.realapi-url-input {\n  width: 100%;\n  height: 42px;\n  background-color: #f8fafc;\n  color: #0f172a;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 10px;\n  padding: 0 34px 0 38px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", monospace;\n  font-size: 13px;\n  font-weight: 500;\n  outline: none;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.realapi-url-input:hover {\n  border-color: #94a3b8;\n  background-color: #ffffff;\n}\n\n.realapi-url-input:focus {\n  border-color: #FD6101;\n  background-color: #ffffff;\n  box-shadow: 0 0 0 3px rgba(253, 97, 1, 0.15);\n}\n\n.realapi-url-clear-btn {\n  position: absolute;\n  right: 10px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background-color: #e2e8f0;\n  border: none;\n  color: #64748b;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  line-height: 1;\n}\n\n.realapi-url-clear-btn:hover {\n  background-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.realapi-send-btn {\n  height: 42px;\n  background: #10b981;\n  color: #ffffff;\n  border: none;\n  padding: 0 24px;\n  border-radius: 10px;\n  font-weight: 700;\n  font-size: 13.5px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.realapi-send-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.35);\n}\n\n.realapi-send-btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.realapi-send-shortcut {\n  font-size: 10.5px;\n  background: rgba(255, 255, 255, 0.22);\n  padding: 2px 6px;\n  border-radius: 5px;\n  font-weight: 600;\n}\n\n/* 4. WORKBENCH TWO-PANEL STUDIO GRID */\n.realapi-studio-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 22px;\n  min-height: calc(100vh - 280px);\n  align-items: stretch;\n}\n\n@media (max-width: 1200px) {\n  .realapi-studio-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.realapi-card {\n  background-color: #ffffff;\n  border-radius: 18px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 8px 24px -4px rgba(0, 0, 0, 0.03), 0 2px 6px rgba(0, 0, 0, 0.02);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.realapi-card-header {\n  padding: 18px 22px 14px;\n  border-bottom: 1px solid #f1f5f9;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  background-color: #fafbfc;\n}\n\n.realapi-card-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.realapi-sub-tabs {\n  display: flex;\n  gap: 4px;\n  background: #f1f5f9;\n  border-radius: 10px;\n  padding: 3px;\n  border: 1px solid #e2e8f0;\n}\n\n.realapi-sub-tab {\n  padding: 6px 14px;\n  border-radius: 7px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  transition: all 0.15s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.realapi-sub-tab.active {\n  background: #ffffff;\n  color: #0f172a;\n  font-weight: 700;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.realapi-badge-count {\n  font-size: 10px;\n  padding: 1px 6px;\n  border-radius: 10px;\n  background: #e2e8f0;\n  color: #475569;\n  font-weight: 700;\n}\n\n.realapi-sub-tab.active .realapi-badge-count {\n  background: #FD6101;\n  color: #ffffff;\n}\n\n.realapi-card-body {\n  padding: 20px 22px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n/* 5. TABLE BUILDER FOR PARAMS & HEADERS */\n.realapi-kv-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 14px;\n}\n\n.realapi-kv-table th {\n  text-align: left;\n  font-size: 11px;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 8px 10px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.realapi-kv-table td {\n  padding: 6px 6px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.realapi-kv-input {\n  width: 100%;\n  height: 36px;\n  background-color: #f8fafc;\n  color: #0f172a;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  padding: 0 10px;\n  font-size: 12.5px;\n  outline: none;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  box-sizing: border-box;\n}\n\n.realapi-kv-input:focus {\n  border-color: #FD6101;\n  background-color: #ffffff;\n}\n\n.realapi-kv-del-btn {\n  background: transparent;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.realapi-kv-del-btn:hover {\n  background-color: #fee2e2;\n  color: #dc2626;\n}\n\n.realapi-table-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 8px;\n}\n\n.realapi-link-btn {\n  background: transparent;\n  border: none;\n  color: #FD6101;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.realapi-link-btn:hover {\n  background-color: #fff7ed;\n}\n\n/* 6. BODY CONFIGURATION */\n.realapi-body-types {\n  display: flex;\n  gap: 14px;\n  margin-bottom: 14px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.realapi-radio-label {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #475569;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.realapi-body-editor {\n  width: 100%;\n  flex: 1;\n  min-height: 240px;\n  background-color: #0f172a;\n  color: #38bdf8;\n  border: 1.5px solid #1e293b;\n  border-radius: 12px;\n  padding: 16px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12.5px;\n  line-height: 1.5;\n  outline: none;\n  box-sizing: border-box;\n  resize: vertical;\n}\n\n.realapi-body-editor:focus {\n  border-color: #FD6101;\n}\n\n/* 7. AUTH CONFIGURATION */\n.realapi-auth-box {\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 18px;\n}\n\n/* 8. RESPONSE TELEMETRY HEADER */\n.realapi-telemetry-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.realapi-status-badge {\n  padding: 7px 14px;\n  border-radius: 9px;\n  font-weight: 800;\n  font-size: 13px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.realapi-status-badge.status-2xx {\n  background-color: #ecfdf5;\n  color: #059669;\n  border: 1px solid #a7f3d0;\n}\n\n.realapi-status-badge.status-3xx {\n  background-color: #eff6ff;\n  color: FD6101;\n  border: 1px solid #bfdbfe;\n}\n\n.realapi-status-badge.status-4xx {\n  background-color: #fff7ed;\n  color: #ea580c;\n  border: 1px solid #fed7aa;\n}\n\n.realapi-status-badge.status-5xx {\n  background-color: #fef2f2;\n  color: #dc2626;\n  border: 1px solid #fca5a5;\n}\n\n.realapi-status-badge.status-err {\n  background-color: #fef2f2;\n  color: #dc2626;\n  border: 1px solid #fca5a5;\n}\n\n.realapi-metric-pill {\n  padding: 7px 12px;\n  border-radius: 9px;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  font-size: 12px;\n  font-weight: 700;\n  color: #334155;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* 9. SOCKET PHASE WATERFALL CHART */\n.realapi-waterfall-card {\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 18px 20px;\n  margin-bottom: 16px;\n}\n\n.realapi-waterfall-title {\n  font-size: 11.5px;\n  font-weight: 800;\n  color: #FD6101;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  margin-bottom: 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.realapi-waterfall-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 12px;\n  gap: 12px;\n}\n\n.realapi-waterfall-label {\n  width: 130px;\n  font-weight: 600;\n  color: #475569;\n  flex-shrink: 0;\n}\n\n.realapi-waterfall-track {\n  flex: 1;\n  background-color: #e2e8f0;\n  height: 10px;\n  border-radius: 5px;\n  overflow: hidden;\n  position: relative;\n}\n\n.realapi-waterfall-bar {\n  height: 100%;\n  border-radius: 5px;\n  transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.realapi-waterfall-val {\n  width: 75px;\n  text-align: right;\n  font-weight: 800;\n  color: #0f172a;\n  flex-shrink: 0;\n  font-family: ui-monospace, SFMono-Regular, monospace;\n}\n\n/* 10. RESPONSE BODY PREVIEW */\n.realapi-response-body-box {\n  background-color: #0f172a;\n  color: #a7f3d0;\n  padding: 16px 20px;\n  border-radius: 12px;\n  overflow: auto;\n  flex: 1;\n  min-height: 250px;\n  max-height: 480px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  line-height: 1.6;\n  border: 1px solid #1e293b;\n  margin: 0;\n}\n\n/* 11. EMPTY STATE LAUNCHPAD */\n.realapi-empty-launchpad {\n  padding: 36px 24px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.realapi-empty-icon {\n  width: 68px;\n  height: 68px;\n  border-radius: 20px;\n  background: #fff7ed;\n  border: 1.5px solid #fed7aa;\n  color: #FD6101;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n  margin-bottom: 16px;\n  box-shadow: 0 8px 20px -4px rgba(253, 97, 1, 0.2);\n}\n\n.realapi-empty-title {\n  font-size: 17px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0 0 6px 0;\n}\n\n.realapi-empty-subtext {\n  font-size: 13px;\n  color: #64748b;\n  max-width: 440px;\n  margin: 0 0 24px 0;\n  line-height: 1.5;\n}\n\n.realapi-sample-cards {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  width: 100%;\n  max-width: 520px;\n  text-align: left;\n}\n\n.realapi-sample-card {\n  background-color: #f8fafc;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 12px 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.realapi-sample-card:hover {\n  border-color: #FD6101;\n  background-color: #ffffff;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px -2px rgba(253, 97, 1, 0.12);\n}\n\n.realapi-sample-method {\n  font-size: 10px;\n  font-weight: 800;\n  padding: 2px 7px;\n  border-radius: 6px;\n  display: inline-block;\n  margin-bottom: 5px;\n}\n\n.realapi-sample-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 3px;\n}\n\n.realapi-sample-desc {\n  font-size: 11px;\n  color: #64748b;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* 12. HISTORY DRAWER */\n.realapi-history-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 380px;\n  background-color: #ffffff;\n  border-left: 1px solid #e2e8f0;\n  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.08);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  animation: slideDrawer 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes slideDrawer {\n  from {\n    transform: translateX(100%);\n  }\n\n  to {\n    transform: translateX(0);\n  }\n}\n\n.realapi-history-header {\n  padding: 20px 22px;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.realapi-history-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 14px;\n}\n\n.realapi-history-item {\n  padding: 12px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  background-color: #fafbfc;\n}\n\n.realapi-history-item:hover {\n  border-color: #FD6101;\n  background-color: #ffffff;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
